// All mock data for the Agero landing page clone

export const nav = {
  logo: "Agero.",
  links: [
    { label: "Works", href: "#works" },
    { label: "Services", href: "#services" },
    { label: "About", href: "#about" },
    { label: "Blog", href: "#blog" },
  ],
  cta: { label: "Contact", href: "#contact" },
  status: "Available for New Projects",
};

export const hero = {
  founders: [
    "https://framerusercontent.com/images/LdiJIgo7vhBde0WiWHd48uSzxU.png?width=512&height=512",
    "https://framerusercontent.com/images/I9yoNS4RgoWEeRpJDtgEIoLAd4Y.png?width=512&height=512",
    "https://framerusercontent.com/images/G5E86VA7DStEga3pPtCu3nwW1qE.png?width=512&height=512",
  ],
  trusted: "Trusted by founders.",
  inlineImg1: "https://framerusercontent.com/images/q6Lt0wxatBudeFMJylqNDhblWfw.png?width=325&height=256",
  inlineImg2: "https://framerusercontent.com/images/SEe6jn6sx24EVdMsr0kTyBN4Ok.png?width=324&height=256",
  subtitle:
    "We make it easy for startups to launch, grow, and scale with clean, conversion focused designs — no delays, no drama.",
  cta: { label: "View Plans", href: "#pricing" },
  banner:
    "https://framerusercontent.com/images/dT5S1njJpyHvznBNeTmMAwfBcqQ.png?width=2848&height=1604",
};

export const clientLogos = [
  "https://framerusercontent.com/images/3cWSgJFsUVvZeOw9LdQmTOSVFhE.svg?width=58&height=32",
  "https://framerusercontent.com/images/nfabfL1KTOOmw22T9soWodkE5Q.svg?width=127&height=32",
  "https://framerusercontent.com/images/pFmkT2mGzyfTzJsLN2Lr3fdbIk.svg",
  "https://framerusercontent.com/images/oqkjAivG8qVmaPBg07Z4Yst8rwk.svg?width=162&height=32",
  "https://framerusercontent.com/images/nmwtsE1SWD34rSXL3OhLE7CTn0.svg?width=83&height=32",
  "https://framerusercontent.com/images/zhMiNUjAyE25vd6XOETCIwS38.svg?width=131&height=32",
];

export const marqueeTopItems = [
  "Website Design",
  "Brand Design",
  "Logo Design",
];

export const marqueeBottomItems = [
  "Senior Designer",
  "10 Years of Experience",
  "Over 100 Customers",
];

export const statement = {
  eyebrow: "(hello)",
  parts: [
    { text: "We help fast moving digital startups launch sharper brands and websites — with ", muted: false },
    { text: "clarity, speed, and no drama.", muted: true },
  ],
  tags: [
    { label: "Branding", icon: "Sparkles" },
    { label: "Logo", icon: "Globe" },
    { label: "Website", icon: "Globe" },
    { label: "Illustration", icon: "PenTool" },
    { label: "Interface", icon: "LayoutPanelLeft" },
    { label: "Strategy", icon: "Compass" },
  ],
};

export const testimonialsSection = {
  eyebrow: "(Why clients love Agero)",
  title: "Testimonials",
  stats: [
    { value: "50+", label: "Finalized Projects" },
    { value: "98%", label: "Client satisfaction rate" },
    { value: "1M", label: "Gross Revenue" },
  ],
  items: [
    {
      image: "https://framerusercontent.com/images/nURHcgFo9S6zVF3j0ly85sSmvE.png?width=1488&height=920",
      quote:
        "Franklin turned our ideas into a sharp, clean brand. Fast, easy, and right on point.",
      name: "Ethan Moore",
      role: "Co-founder, NovaTech",
    },
    {
      image: "https://framerusercontent.com/images/j4kitBgDVx6ElGDAGtpxlM7RoHg.png?width=1488&height=920",
      quote:
        "Clear, thoughtful, and fast — Franklin made the whole process effortless.",
      name: "Olivia Tran",
      role: "Creative Director, Bloom Agency",
    },
    {
      image: "https://framerusercontent.com/images/4be4S5coR2QthuRAfsb7USMjRZ0.png?width=1488&height=920",
      quote: "Smart design, smooth delivery. Franklin is great to work with.",
      name: "Lucas Bennett",
      role: "Product Manager, Hexa Studio",
    },
  ],
};

export const recentWorks = {
  eyebrow: "(Selected Work)",
  title: "Recent Works",
  items: [
    {
      name: "Archin",
      desc: "We've helped businesses across industries achieve their goals. Here are some of our selected works.",
      cover: "https://framerusercontent.com/images/olR1jd1vAg59BKYSorw26ZNxY.png",
      year: "2025",
      role: "Lead Designer",
      services: ["Website Design", "Product Design", "Branding", "Development"],
    },
    {
      name: "VNTNR",
      desc: "We've partnered with businesses across various industries to help them achieve their goals.",
      cover: "https://framerusercontent.com/images/QhPkJGJBXS8kPS7IhPj7ZBGZpII.png",
      year: "2018",
      role: "Logo Designer",
      services: ["Designing", "Branding", "Redesigning", "Development"],
    },
    {
      name: "Aeorim",
      desc: "We've collaborated with companies from diverse sectors to turn their visions into reality.",
      cover: "https://framerusercontent.com/images/yOPV9nZRSJXmNPqyeWfZSThWAc.png",
      year: "2023",
      role: "Website Designer",
      services: ["Branding", "Revamp", "Development", "Designing"],
    },
  ],
};

export const services = {
  eyebrow: "(Services)",
  title: "What we do",
  tabs: [
    {
      label: "Web Design",
      title: "We craft fast, responsive websites that convert visitors into customers.",
      image: "https://framerusercontent.com/images/L3jNOIvjVNNJ9KYGN7ZewlhM4.png",
      features: ["Responsive Layouts", "Design Systems", "No-code Framer"],
    },
    {
      label: "Brand Design",
      title: "We build bold, cohesive brand identities that leave a lasting impression.",
      image: "https://framerusercontent.com/images/L3jNOIvjVNNJ9KYGN7ZewlhM4.png",
      features: ["Visual Identity", "Style Guides", "Brand Strategy"],
    },
    {
      label: "Logo Design",
      title: "We design timeless logos that capture the essence of your brand.",
      image: "https://framerusercontent.com/images/L3jNOIvjVNNJ9KYGN7ZewlhM4.png",
      features: ["Logo Concepts", "Iconography", "Wordmarks"],
    },
  ],
};

export const founder = {
  eyebrow: "(Intro)",
  title: "Meet Finton",
  image: "https://framerusercontent.com/images/cdiudTEW8MSbl2008vSYXSq9ndI.png",
  circle: "https://framerusercontent.com/images/JpJ9ryMkQp811zxkS5X8I8Igdo.png",
  label: "The Founder",
  bio: "Franklin Clinton is a visual designer focused on crafting bold, functional design systems. He works with creative teams and startups to build standout brands and seamless digital experiences. Based in London, he balances clarity with character — and enjoys experimenting with motion design and interactive visuals in his spare time.",
  timeline: [
    { role: "Founder at Agero", period: "2024-Now" },
    { role: "Brand Designer at Google", period: "2023-2024" },
    { role: "Web Designer at Shopify", period: "2018-2023" },
    { role: "Junior Designer at Meta", period: "2015-2018" },
  ],
};

export const awards = {
  eyebrow: "(Awards)",
  title: "Awards Winning",
  items: [
    { org: "Awwwards", award: "SOTY 2023 - 1st Winner", project: "Archin" },
    { org: "CSS Awards", award: "Top 5 Best of eCommerce Websites 2023", project: "VNTNR" },
    { org: "CSS Awards", award: "Winner - US Behance Portfolio Review 2024", project: "Aeorim" },
    { org: "Dribbble", award: "Top 10 Best of Mobile App Design 2024", project: "Swat Co." },
    { org: "FWA Awards", award: "Winner - Best of Architecture Website 2025", project: "Unerio" },
  ],
};

export const pricing = {
  eyebrow: "(Pricing Plan)",
  title: "Explore Pricing",
  plans: [
    {
      name: "Standard Plan",
      icon: "https://framerusercontent.com/images/hkdh85c5wuRaQUC0E3ZaA2YqhY.png",
      desc: "Ideal for lean teams or startups needing clean, fast design delivery for websites or branding assets.",
      delivery: "4-6 weeks",
      priceLabel: "",
      price: "$500",
      per: "/month",
      features: [
        "You provide the wireframe",
        "Visual design using Figma & Framer",
        "Focused on website or branding only",
        "Weekday turnaround (Mon–Fri)",
      ],
      dark: false,
    },
    {
      name: "Premium Plan",
      icon: "https://framerusercontent.com/images/z20as7qIn0WJioZel35OsXkADw.svg",
      desc: "A complete design experience — tailored strategy, polished visuals, and flexible collaboration throughout the process.",
      delivery: "4-6 weeks",
      priceLabel: "Starting at",
      price: "$1000",
      per: "",
      features: [
        "Help shaping your wireframe or brief",
        "Custom design for website, brand, or logo",
        "High-fidelity mockups using Figma & Framer",
        "Dedicated weekday focus & deeper involvement",
      ],
      dark: true,
    },
  ],
};

export const faqs = {
  eyebrow: "(FAQs)",
  title: "Your Questions, Answered",
  subtitle: "Helping you understand our process and offerings at Agero.",
  items: [
    {
      q: "Why's Agero instead of a full-time designer?",
      a: "Agero gives you senior design talent on demand without the overhead of a full-time hire. You get flexibility, speed, and a fresh perspective on every project.",
    },
    {
      q: "Speed of design delivery?",
      a: "Pretty quick! Most designs are delivered in 2–3 business days. We prioritize quality without slowing you down.",
    },
    {
      q: "What's the Agero progress like?",
      a: "We start with a kickoff to align on goals, then move through iterative design rounds with clear communication at every step.",
    },
    {
      q: "How to request a design?",
      a: "Simply send us a brief through our contact form or dashboard. We'll review and get started right away.",
    },
    {
      q: "What if I don't like the design?",
      a: "No worries — revisions are included. We iterate until you're completely happy with the result.",
    },
    {
      q: "Are there any refunds?",
      a: "Yes, we offer a satisfaction guarantee. If we're not the right fit, we'll make it right.",
    },
  ],
};

export const contact = {
  title: "Let's Connect",
  headline: "Got a project in mind?",
  sub: "Let's make something happen together",
  email: "franklin@agero.com",
  fields: {
    name: "Your Name",
    email: "Your Email",
    message: "Project Description",
    submit: "Send Now!",
  },
};

export const footerTemplates = [
  "https://framerusercontent.com/images/aR3TKcVMliXQPWIhQTclJhXcTMg.png?width=1600&height=1200",
  "https://framerusercontent.com/images/69auPD1YzLBCNcO5v9D5nks5aS4.png?width=3200&height=2400",
  "https://framerusercontent.com/images/YDnxl1a68JhgSkmG8E0skqnoFM.png?width=1600&height=1200",
  "https://framerusercontent.com/images/bUQhIsAv8wdGMuDZ6cBmNmLqJmc.png?width=1760&height=1320",
];
